import { render, staticRenderFns } from "./AdminSelect.vue?vue&type=template&id=96332bba&"
import script from "./AdminSelect.vue?vue&type=script&lang=js&"
export * from "./AdminSelect.vue?vue&type=script&lang=js&"
import style0 from "./AdminSelect.vue?vue&type=style&index=0&id=96332bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports